module.exports = __webpack_public_path__ + "static/media/my-certificates.3b9fa11f.png";